import { render, staticRenderFns } from "./ProductRemoval.vue?vue&type=template&id=6df267a0"
import script from "./ProductRemoval.vue?vue&type=script&lang=js"
export * from "./ProductRemoval.vue?vue&type=script&lang=js"
import style0 from "./ProductRemoval.vue?vue&type=style&index=0&id=6df267a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports